import { FileReader, FileWriter } from "@/platform";
import ModuleId from "./DataStructModuleId";
class GameArray {

	public mid = ModuleId.gameArray
	public Data: Array<String> = new Array();

    constructor(){
        this.Data = []
        this.Data.push("数组示例1")
        for (let i: number = 0; i < 49; i++) {
			this.Data.push("");
		}
    }

    readBin(reader: FileReader): void {
		const len = reader.readInt()
		this.Data = []
        for ( var i = 0; i < len; i++ ){
			let str = reader.readString()
			this.Data.push(str)
		}
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.Data.length)
        for (let i = 0; i < this.Data.length; i++) {
            writer.writeString(this.Data[i]?.toString() ?? "")
        }
    }
}
export default GameArray